
define('template!portalOverviewTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="overview-card">\n  <div class="overview-card__head">\n    <span class="overview-card__title">\n      ' +
((__t = ( all
        ? _.i18n('portalUsers.overview.titleAll', null, 'All shared suppliers')
        : _.i18n('portalUsers.overview.title', null, 'Suppliers using the portal') )) == null ? '' : __t) +
'\n    </span>\n\n    <button type="button" class="btn btn-sm js-toggle-all">\n      ' +
((__t = ( all
        ? _.i18n('portalUsers.overview.showActive', null, 'Only those in use')
        : _.i18n('portalUsers.overview.showAll', null, 'Show every supplier') )) == null ? '' : __t) +
'\n    </button>\n  </div>\n\n  ';
 if (failed) { ;
__p += '\n    <p class="overview-card__warning">\n      ' +
((__t = ( _.i18n('portalUsers.overview.failed', null,
        'Could not read the overview. Pick a supplier below to see its settings.') )) == null ? '' : __t) +
'\n    </p>\n  ';
 } else if (empty) { ;
__p += '\n    <p class="overview-card__empty">\n      ' +
((__t = ( all
        ? _.i18n('portalUsers.overview.noSuppliers', null, 'No suppliers are shared with this account.')
        : _.i18n('portalUsers.overview.noneActive', null,
            'No supplier uses the portal yet — nobody is routed here and no account has been created.') )) == null ? '' : __t) +
'\n    </p>\n  ';
 } else { ;
__p += '\n    <table class="overview-table">\n      <thead>\n        <tr>\n          <th>' +
((__t = ( _.i18n('portalUsers.supplier', null, 'Supplier') )) == null ? '' : __t) +
'</th>\n          <th>' +
((__t = ( _.i18n('portalUsers.overview.routed', null, 'Orders routed here') )) == null ? '' : __t) +
'</th>\n          <th>' +
((__t = ( _.i18n('portalUsers.overview.sections', null, 'Can open') )) == null ? '' : __t) +
'</th>\n          <th>' +
((__t = ( _.i18n('portalUsers.overview.accounts', null, 'Accounts') )) == null ? '' : __t) +
'</th>\n        </tr>\n      </thead>\n      <tbody>\n        ';
 _.each(rows, function (row) { ;
__p += '\n          <tr class="overview-row js-row" data-secid="' +
((__t = ( row.supplierSecId )) == null ? '' : __t) +
'">\n            <td>\n              <span class="overview-row__code">' +
((__t = ( row.code )) == null ? '' : __t) +
'</span>\n              <span class="overview-row__name">' +
((__t = ( row.name )) == null ? '' : __t) +
'</span>\n            </td>\n\n            <td>\n              ';
 if (row.usePortal) { ;
__p += '\n                <span class="pill pill--on">' +
((__t = ( _.i18n('common.yes', null, 'Yes') )) == null ? '' : __t) +
'</span>\n              ';
 } else { ;
__p += '\n                <span class="pill">' +
((__t = ( _.i18n('common.no', null, 'No') )) == null ? '' : __t) +
'</span>\n              ';
 } ;
__p += '\n              ';
 if (row.allowLabels) { ;
__p += '\n                <span class="pill pill--quiet">' +
((__t = ( _.i18n('portalUsers.overview.labels', null, 'labels') )) == null ? '' : __t) +
'</span>\n              ';
 } ;
__p += '\n            </td>\n\n            <td class="overview-row__sections">\n              ';
 if (!row.orders && !row.products && !row.team) { ;
__p += '\n                <span class="pill pill--off">' +
((__t = ( _.i18n('portalUsers.overview.nothing', null, 'nothing') )) == null ? '' : __t) +
'</span>\n              ';
 } else { ;
__p += '\n                ';
 if (row.orders) { ;
__p += '\n                  <span class="pill pill--quiet">' +
((__t = ( _.i18n('portalUsers.sections.orders', null, 'Orders') )) == null ? '' : __t) +
'</span>\n                ';
 } ;
__p += '\n                ';
 if (row.products) { ;
__p += '\n                  <span class="pill pill--quiet">' +
((__t = ( _.i18n('portalUsers.sections.products', null, 'Products') )) == null ? '' : __t) +
'</span>\n                ';
 } ;
__p += '\n                ';
 if (row.team) { ;
__p += '\n                  <span class="pill pill--quiet">' +
((__t = ( _.i18n('portalUsers.sections.team', null, 'Accounts') )) == null ? '' : __t) +
'</span>\n                ';
 } ;
__p += '\n              ';
 } ;
__p += '\n            </td>\n\n            <td>\n              <span class="num">' +
((__t = ( row.activeAccounts )) == null ? '' : __t) +
'</span>\n              ';
 if (row.accounts !== row.activeAccounts) { ;
__p += '\n                <span class="overview-row__muted">/ ' +
((__t = ( row.accounts )) == null ? '' : __t) +
'</span>\n              ';
 } ;
__p += '\n              ';

                /* Someone can sign in, but no order will ever reach them: almost
                   always a setup left half done. */
              ;
__p += '\n              ';
 if (row.signedInButUnrouted) { ;
__p += '\n                <span class="overview-row__flag"\n                      title="' +
((__t = ( _.i18n('portalUsers.overview.unroutedHint', null,
                        'Accounts exist but orders are not routed here, so their queue stays empty.') )) == null ? '' : __t) +
'">!</span>\n              ';
 } ;
__p += '\n            </td>\n          </tr>\n        ';
 }); ;
__p += '\n      </tbody>\n    </table>\n  ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

